import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FilterChip } from '../filter-chips.component';

@Component({
  selector: 'kion-filter-chip-list-item',
  templateUrl: './filter-chip-list-item.component.html',
  styleUrls: ['./filter-chip-list-item.component.scss']
})
export class FilterChipListItemComponent {

  @Input() chip: FilterChip;
  @Input() isClicked: boolean;
  // tslint:disable-next-line:no-output-rename
  @Output('selected') chipSelectedEmitter: EventEmitter<FilterChip> = new EventEmitter<FilterChip>();

  constructor() { }

  chipClicked():void {
    this.chipSelectedEmitter.emit(this.chip);
  }
}
